import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../../../firebaseConfig';
import { markNotificationAsRead } from '../utils.js';

export const handleMessageNotificationClick = async (notification, navigate) => {
  try {
    // Mark as read
    await markNotificationAsRead(notification.id);

    if (notification.conversationId) {
      navigate(`/home?conversationId=${notification.conversationId}`);
    } else if (notification.actionUrl) {
      // Normalize legacy /chat links to /home
      const normalized = String(notification.actionUrl).startsWith('/chat')
        ? notification.actionUrl.replace('/chat', '/home')
        : notification.actionUrl;
      navigate(normalized);
    } else if (notification.actorId) {
      try {
        const ensureConv = httpsCallable(functions, 'ensureDirectConversation');
        const res = await ensureConv({ targetUserId: notification.actorId });
        const conversationId = res?.data?.conversationId;
        if (conversationId) {
          navigate(`/home?conversationId=${conversationId}`);
        } else {
          navigate('/home');
        }
      } catch (e) {
        navigate('/home');
      }
    } else {
      navigate('/home');
    }

    return { success: true };
  } catch (error) {
    console.error('Error handling message notification:', error);
    return { success: false, error };
  }
};
